import React, {useEffect, useMemo, useState} from "react";
import styled from "styled-components";
import _ from "lodash";
import {useSelector} from "react-redux";

const FadeInBox = styled.div`
  animation: fadein 1s linear;

  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;


// 1 = 우주최강 올라프
// 2 = 쭌베
// 3 = 양거북
// 4 = 좋은 친구들
// 5 = 우정잉
// 6 = U4
// 7 = 이상호
// 8 = 윤수빈
const Adcalc = (value) => {
    if (value <= 200) {
        return 8
    } else if (value <= 500) {
        return 7
    } else if (value <= 700) {
        return 6
    } else if (value <= 850) {
        return 4
    } else if(value <= 925) {
        return 98
    }
    return 99
};

const randomNumber100 = () => {
    return _.random(1, 1000);
}
const KoreanAd = () => {
    const currentLang = useSelector((state) => state.translation.lang);

    const [adState, setAdState] = useState(() => {
        return Adcalc(randomNumber100())
    });


    const changeState = () => {
        setAdState(prev => {
            let result = prev;
            while (true) {
                if (result !== prev) {
                    break;
                } else {
                    result = Adcalc(randomNumber100());
                }
            }
            return result
        })
    }


    if(currentLang !== 'KOR') {
        return null
    }

    if ([4].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState4"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://discord.com/invite/111'} target={'_blank'}>
                        <img src={'./images/ad/ad_state4.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([6].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState6"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://play.sooplive.co.kr/lch9835/283903250'} target={'_blank'}>
                        <img src={'./images/ad/ad_state6.jpg'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([7].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState7"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://ch.sooplive.co.kr/lshooooo'} target={'_blank'}>
                        <img src={'./images/ad/ad_state7.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([8].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState8"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://www.instagram.com/forest.y_u/'} target={'_blank'}>
                        <img src={'./images/ad/ad_state8.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }





    if ([98].includes(adState)) {
        return (
            <TimeOutBox time={5000} changeState={changeState} key={adState}>
                <FadeInBox>
                    <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6?pvs=4'}
                       target={'_blank'}>
                        <img src={'./images/ad/ad_deeplol_spot.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([99].includes(adState)) {
        return (
            <TimeOutBox time={5000} changeState={changeState} key={adState}>
                <FadeInBox key={adState}>
                    <a href={'https://deeplol-notice.notion.site/1caf4d23843f80f6825bc091b413b7c6?pvs=4'}
                       target={'_blank'}>
                        <img src={'./images/ad/ad_deeplol_spot2.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }


    return (
        <TimeOutBox time={10000} changeState={changeState}>
            <FadeInBox>
                <img src={'./images/ad/ad_state4.png'} width={'100%'} height={120} alt={''}
                />
            </FadeInBox>
        </TimeOutBox>
    )
}


const TimeBox = () => {
    const time = useMemo(() => {
        const date = new Intl.DateTimeFormat('en', {
            timeZone: 'Asia/Seoul',
            hour12: false,
            hour: '2-digit'
        }).format(new Date());
        return Number(date)
    }, []);

    const href = useMemo(() => {
        if (time > 2 && time < 18) {
            return "https://www.youtube.com/shorts/7XUrRjSMNCg"
        } else {
            return "https://chzzk.naver.com/eb509a24d92170db1ba9bafb58696be0"
        }
    }, [time]);


    return (
        <FadeInBox>
            <a href={href} target={'_blank'}>
                <img src={'./images/ad/ad_state3.png'} width={'100%'} height={120} alt={''}
                />
            </a>
        </FadeInBox>
    )
}

const TimeOutBox = ({time, changeState, children}) => {
    useEffect(() => {
        const timeout = setTimeout(() => {
            changeState();
        }, time)
        return () => {
            clearTimeout(timeout)
        }
    }, [])
    return children
}


export default KoreanAd